import axios from "../../helpers/axios"
import { paymentListConstants } from '../constants';

export const getPaymentList = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: paymentListConstants.GET_PAYMENT_LIST_REQUEST })
            const res = await axios.get("paymentList/get")
            if (res.status === 200) {
                const { paymentList } = res.data
                dispatch({
                    type: paymentListConstants.GET_PAYMENT_LIST_SUCCESS,
                    payload: {
                        paymentList
                    }
                })
            } else {
                dispatch({ type: paymentListConstants.GET_PAYMENT_LIST_FAILURE })
            }
        } catch (e) {
            console.log(e)
        }
    }
}